export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const USER_SAVE_SUCCESS = 'USER_SAVE_SUCCESS';
export const USER_SAVE_START = 'USER_SAVE_START';
export const USER_SAVE_ERROR = 'GET_USERS_ERROR';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';
export const USER_ROLE_SUCCEESS = 'USER_ROLE_SUCCEESS';
